import { ReactNode } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { StickyMobileCta } from "./StickyMobileCta";
import { ScrollProgress } from "./ScrollProgress";

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ScrollProgress />
      <SiteHeader />
      <main className="flex-1 pt-16">{children}</main>
      <SiteFooter />
      <StickyMobileCta />
      <div aria-hidden className="h-20 lg:hidden" />
    </div>
  );
}

export function Eyebrow(_props: { children: ReactNode }) {
  // Eyebrow-Badges wurden entfernt (Design-Entscheidung).
  return null;
}
